/**
 * Shared CAMEL Constants
 *
 * CAMEL component configuration for radar charts and component displays.
 * Used by both InstitutionDashboard and Analyst Bench.
 */

// ============================================
// Types
// ============================================

export type CAMELCode = 'C' | 'EG' | 'L' | 'R' | 'S' | 'STI';

export interface CAMELComponent {
  code: CAMELCode;
  score: number;
}

export interface CAMELLabelConfig {
  name: string;
  shortName: string;
  max: number;
}

// ============================================
// Constants
// ============================================

/**
 * CAMEL component labels with display names and maximum scores
 * Max scores are based on the BankingLATAM CAMEL methodology weights
 */
export const camelLabels: Record<CAMELCode, CAMELLabelConfig> = {
  'C': { name: 'Calidad de Activos', shortName: 'Activos', max: 24 },
  'EG': { name: 'Eficiencia y Gestión', shortName: 'Eficiencia', max: 10 },
  'L': { name: 'Liquidez', shortName: 'Liquidez', max: 30 },
  'R': { name: 'Rentabilidad', shortName: 'Rentabilidad', max: 10 },
  'S': { name: 'Solvencia', shortName: 'Solvencia', max: 12 },
  'STI': { name: 'Sensibilidad Tasa Interés', shortName: 'Sensibilidad', max: 20 },
};

/**
 * Ordered CAMEL codes for consistent display
 * Used in gauge ordering
 */
export const orderedCamelCodes: CAMELCode[] = ['C', 'EG', 'L', 'R', 'S', 'STI'];

/**
 * Alternative ordering for radar chart (visual balance)
 * Arranges labels so longer names are at top/bottom, shorter at sides
 */
export const radarOrderedCodes: CAMELCode[] = ['STI', 'R', 'L', 'EG', 'C', 'S'];

/**
 * Mapping from CAMEL code to indicator category name
 * Used to group sankeyIndicators by CAMEL component
 */
export const categoryMapping: Record<CAMELCode, string> = {
  'C': 'Calidad de Activos',
  'EG': 'Eficiencia y Gestion',
  'L': 'Liquidez',
  'R': 'Rentabilidad',
  'S': 'Solvencia',
  'STI': 'Sensibilidad Tasa Interes',
};
